// Form Module
//
//
//
//
//
//
export function initForm() {
    

    /////////////////////////////////////////////////////////////////
    // DATENSCHUTZ CHECKBOX
    /////////////////////////////////////////////////////////////////


    document.querySelectorAll('form').forEach(form => {
    const checkbox = form.querySelector('.datenschutz-checkbox');
    const submitButton = form.querySelector('.formsend-button');

    if (checkbox && submitButton) {
        // Set initial state
        submitButton.disabled = !checkbox.checked;
        submitButton.classList.add('button--disabled');

        checkbox.addEventListener('change', function() {
            // Find the submit button within the same form as this checkbox
            const formSubmitButton = this.closest('form').querySelector('.formsend-button');
            formSubmitButton.disabled = !this.checked;
            formSubmitButton.classList.toggle('button--disabled', !this.checked);
            });
        }
    });


/////////////////////////////////////////////////
// Adresse suchen
//////////////////////////////////////////////////

if (document.querySelectorAll('.address-container').length > 0) {

    const input = document.getElementById('addressForm');
    const suggestions = document.getElementById('suggestions');
    
    input.addEventListener('input', async () => {
      const query = input.value;
      if (query.length < 3) {
        suggestions.style.display = 'none';
        return;
      }
    
      try {
        const res = await fetch(`https://photon.komoot.io/api/?q=${encodeURIComponent(query)}&limit=5&lang=de`);
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
    
        suggestions.innerHTML = '';
        if (data.features && data.features.length > 0) {
          data.features.forEach(feature => {
            const li = document.createElement('li');
            
            // Build display text from available properties
            let displayText = '';
            if (feature.properties.street && feature.properties.housenumber) {
              displayText = `${feature.properties.street} ${feature.properties.housenumber}`;
            } else if (feature.properties.street) {
              displayText = feature.properties.street;
            } else if (feature.properties.name) {
              displayText = feature.properties.name;
            }
            
            if (feature.properties.city) {
              displayText += `, ${feature.properties.city}`;
            }
            if (feature.properties.postcode) {
              displayText += ` ${feature.properties.postcode}`;
            }
            
            li.textContent = displayText || feature.properties.label || 'Unnamed location';
            
            li.addEventListener('click', () => {
              const props = feature.properties;
    
              // Build full address for main input
              let fullAddress = '';
              if (props.street && props.housenumber) {
                fullAddress = `${props.street} ${props.housenumber}`;
              } else if (props.street) {
                fullAddress = props.street;
              } else if (props.name) {
                fullAddress = props.name;
              }
              
              if (props.city) {
                fullAddress += `, ${props.city}`;
              }
              if (props.postcode) {
                fullAddress += ` ${props.postcode}`;
              }
              if (props.country) {
                fullAddress += `, ${props.country}`;
              }
    
              // Setze das Hauptfeld
              input.value = fullAddress;
              document.getElementById('addressValue').value = fullAddress;
  
              // Setze strukturierte Felder (soweit verfügbar)
              const street = props.street || props.name || '';
              const housenumber = props.housenumber || '';
              document.getElementById('street').value = street + (housenumber ? ' ' + housenumber : '');
              document.getElementById('postcode').value = props.postcode || '';
              document.getElementById('city').value = props.city || props.name || '';
              document.getElementById('country').value = props.country || '';
    
              suggestions.style.display = 'none';
            });
            suggestions.appendChild(li);
          });
          suggestions.style.display = 'block';
        } else {
          suggestions.style.display = 'none';
        }
      } catch (error) {
        console.error('Error fetching address suggestions:', error);
        suggestions.style.display = 'none';
      }
    });
    
    // Close suggestions when clicking outside
    document.addEventListener('click', (event) => {
      if (!input.contains(event.target) && !suggestions.contains(event.target)) {
        suggestions.style.display = 'none';
      }
    });
    
    }



    /////////////////////////////////////////////////
    // Euro-Input Form Field
    //////////////////////////////////////////////////
  
  
  if (document.querySelectorAll('.input-with-symbol').length > 0) {
    
    const currencyInputs = document.querySelectorAll('.input-with-symbol input');
    
    currencyInputs.forEach(input => {
      // Format number on input
      input.addEventListener('input', function(e) {
        // Remove all non-digit characters
        let value = this.value.replace(/[^\d]/g, '');
        
        // Format with thousand separators
        if (value.length > 0) {
          value = parseInt(value).toLocaleString('de-DE');
        }
        
        this.value = value;
      });
      
      // Format number on blur
      input.addEventListener('blur', function(e) {
        let value = this.value.replace(/[^\d]/g, '');
        if (value.length > 0) {
          this.value = parseInt(value).toLocaleString('de-DE');
        }
      });
      
      // Remove formatting before form submission
      const form = input.closest('form');
      if (form) {
        form.addEventListener('submit', function(e) {
          input.value = input.value.replace(/[^\d]/g, '');
        });
      }
    });
  }




    // END OF MODULE
    console.log("Mega Friendly Form-Module initialized");
}